import { Item } from "../model/item";
import {
    getMinutesFromDate,
    getDateTimeFromMinutes,
    parseDateTimeString,
} from "../utils/date";

// the JSON wire shape of an item: `lock` travels as an ISO datetime string
// (server-side it's parsed into a Date — see ItemEntity in model/item.ts)
export type ItemEntityJson = {
    id: number;
    lock: string | null;
    lockMinutes?: number | null;
    duration: number;
    title: string;
};

export type DaysJson = { [date: string]: Array<ItemEntityJson> };

export const entityJsonToItem = (raw: ItemEntityJson, date: string): Item => ({
    id: raw.id,
    title: raw.title,
    duration: raw.duration,
    lock:
        raw.lockMinutes !== undefined
            ? raw.lockMinutes
            : raw.lock == null
            ? null
            : getMinutesFromDate(parseDateTimeString(raw.lock), date),
});

export const itemToEntityJson = (item: Item, date: string): ItemEntityJson => ({
    id: item.id,
    title: item.title,
    duration: item.duration,
    lockMinutes: item.lock,
    lock: item.lock == null ? null : getDateTimeFromMinutes(date, item.lock),
});
